<template>
  <div class="d-flex flex-column gap-12 mb-6" id="pdf">
    <!--PRINT HEADER-->
    <div
      class="d-flex flex-column align-center to-show"
      style="gap: 14px; display: none; visibility: hidden; height: 0px"
    >
      <div class="d-flex align-center">
        <v-img
          :src="require('@/assets/Logo2.png')"
          width="146"
          height="48"
          aspect-ratio="1"
        ></v-img>
      </div>

      <div class="d-flex align-center">
        <div class="page-title">แบบฟอร์มข้อเสนอโครงการ</div>
      </div>
      <div class="d-flex align-center">
        <div class="txt-head">โดยอุทยานวิทยาศาสตร์ {{ user.region ?? "" }}</div>
      </div>
    </div>

    <!--  PART ONE  -->
    <divcard titled>
      <div class="card-part pt-0">
        <div class="txt-head black--text mb-2">
          <span class="theme-color-one">ส่วนที่ 1 :</span> ข้อมูลทั่วไป
        </div>

        <!-- Form 1 -->
        <div class="d-flex flex-column gap-8">
          <!-- Form 1 #line1 -->
          <div class="d-flex gap-16">
            <ValidatorIcon
              v-if="!$route.query.preview"
              :is-correct="partOneValidate('master_plan')"
            ></ValidatorIcon>

            <div class="d-flex gap-16">
              <div class="mb-1 black--text topic-field">แผนงาน</div>
              <div>
                {{ masterData?.form_b?.plan?.plan_master?.plan_name_th }}
              </div>
            </div>
          </div>
          <div class="d-flex gap-16">
            <ValidatorIcon
              v-if="!$route.query.preview"
              :is-correct="partOneValidate('sci_park')"
            ></ValidatorIcon>

            <div class="d-flex gap-16">
              <div class="mb-1 black--text topic-field">อุทยานวิทยาศาสตร์</div>
              <div>{{ partOneForm?.sci_park }}</div>
            </div>
          </div>

          <!-- Form 1 #line2 -->
          <div class="d-flex gap-16">
            <div class="font-type-bold black--text mb-3">
              ข้อมูลผู้รับผิดชอบโครงการ
            </div>
          </div>

          <!-- Form 1 #line3 -->
          <div class="d-flex gap-16">
            <ValidatorIcon
              v-if="!$route.query.preview"
              :is-correct="partOneValidate('pm_name')"
            ></ValidatorIcon>

            <div class="d-flex gap-16">
              <div class="mb-1 black--text topic-field">ชื่อ - สกุล</div>
              <div>{{ partOneForm?.pm_name }}</div>
            </div>
          </div>

          <!-- Form 1 #line4 -->
          <div class="d-flex gap-16">
            <ValidatorIcon
              v-if="!$route.query.preview"
              :is-correct="partOneValidate('pm_position')"
            ></ValidatorIcon>
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">ตำแหน่ง</div>
              <div>{{ partOneForm?.pm_position }}</div>
            </div>
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">หน่วยงาน</div>
              <div>{{ partOneForm?.pm_org }}</div>
            </div>
          </div>

          <!-- Form 1 #line5 -->
          <div class="d-flex gap-16">
            <ValidatorIcon
              v-if="!$route.query.preview"
              :is-correct="true"
            ></ValidatorIcon>
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">โทรศัพท์</div>
              <div>{{ partOneForm?.pm_phone }}</div>
            </div>
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">โทรสาร</div>
              <div>{{ partOneForm?.pm_fax }}</div>
            </div>
          </div>

          <!-- Form 1 #line6 -->
          <div class="d-flex gap-16">
            <ValidatorIcon
              v-if="!$route.query.preview"
              :is-correct="partOneValidate('pm_mobile_phone')"
            ></ValidatorIcon>
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">โทรศัพท์มือถือ</div>
              <div>{{ partOneForm?.pm_mobile_phone }}</div>
            </div>
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">E-Mail</div>
              <div>{{ partOneForm?.pm_email }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="card-part">
        <!-- Form 1 Part 2 -->
        <div class="d-flex flex-column gap-8">
          <!-- Form 1 Part 2 #line1 -->
          <div class="d-flex gap-16">
            <div class="font-type-bold black--text mb-3">
              ข้อมูลผู้ประสานงานโครงการ
            </div>
          </div>

          <!-- Form 1 Part 2 #line2 -->
          <div class="d-flex gap-16">
            <ValidatorIcon
              v-if="!$route.query.preview"
              :is-correct="partOneValidate('pc_name')"
            ></ValidatorIcon>

            <div class="d-flex gap-16">
              <div class="mb-1 black--text topic-field">ชื่อ - สกุล</div>
              <div>{{ partOneForm?.pc_name }}</div>
            </div>
          </div>

          <!-- Form 1 Part 2 #line3 -->
          <div class="d-flex gap-16">
            <ValidatorIcon
              v-if="!$route.query.preview"
              :is-correct="partOneValidate('pc_position')"
            ></ValidatorIcon>
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">ตำแหน่ง</div>
              <div>{{ partOneForm?.pc_position }}</div>
            </div>
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">หน่วยงาน</div>
              <div>{{ partOneForm?.pc_org }}</div>
            </div>
          </div>

          <!-- Form 1 Part 2 #line5 -->
          <div class="d-flex gap-16">
            <ValidatorIcon
              v-if="!$route.query.preview"
              :is-correct="true"
            ></ValidatorIcon>
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">โทรศัพท์</div>
              <div>{{ partOneForm?.pc_phone }}</div>
            </div>
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">โทรสาร</div>
              <div>{{ partOneForm?.pc_fax }}</div>
            </div>
          </div>

          <!-- Form 1 Part 2 #line6 -->
          <div class="d-flex gap-16">
            <ValidatorIcon
              v-if="!$route.query.preview"
              :is-correct="partOneValidate('pc_mobile_phone')"
            ></ValidatorIcon>
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">โทรศัพท์มือถือ</div>
              <div>{{ partOneForm?.pc_mobile_phone }}</div>
            </div>
            <div class="flex xs6 d-flex gap-16">
              <div class="mb-1 black--text topic-field">E-Mail</div>
              <div>{{ partOneForm?.pc_email }}</div>
            </div>
          </div>
        </div>
      </div>
    </divcard>

    <!--  PART TWO  -->
    <divcard titled>
      <div class="card-part pt-0">
        <div class="txt-head black--text mb-2">
          <span class="theme-color-one">ส่วนที่ 2 :</span> ข้อมูลโครงการ
        </div>
        <div class="card-part">
          <div class="d-flex align-start gap-24 mb-3">
            <ValidatorIcon
              v-if="!$route.query.preview"
              :is-correct="partTwoValidate('principle')"
            ></ValidatorIcon>
            <div class="flex d-flex gap-16">
              <div class="font-type-bold black--text" style="width: 40%">
                1. หลักการและเหตุผล
              </div>
              <div
                style="width: 100%"
                v-html="partTwoForm?.principle?.replace(/\n/g, '<br>')"
              ></div>
            </div>
          </div>
        </div>
      </div>

      <div class="card-part">
        <div class="d-flex align-start gap-24 mb-3">
          <ValidatorIcon
            v-if="!$route.query.preview"
            :is-correct="partTwoValidate('objective')"
          ></ValidatorIcon>
          <div class="flex d-flex gap-16">
            <div class="font-type-bold black--text" style="width: 40%">
              2. วัตถุประสงค์
            </div>
            <div
              style="width: 100%"
              v-html="partTwoForm?.objective?.replace(/\n/g, '<br>')"
            ></div>
          </div>
        </div>
      </div>

      <div class="card-part">
        <div class="d-flex align-start gap-24 mb-3">
          <ValidatorIcon
            v-if="!$route.query.preview"
            :is-correct="partTwoValidate('industry_group')"
          ></ValidatorIcon>
          <div class="flex d-flex gap-16">
            <div class="font-type-bold black--text" style="width: 40%">
              3. ผู้รับบริการ/กลุ่มเป้าหมาย/สาขาอุตสาหกรรม
            </div>
            <div
              style="width: 100%"
              v-html="partTwoForm?.industry_group?.replace(/\n/g, '<br>')"
            ></div>
          </div>
        </div>
      </div>

      <div class="card-part">
        <div class="d-flex align-start gap-24 mb-3">
          <ValidatorIcon
            v-if="!$route.query.preview"
            :is-correct="partTwoValidate('target')"
          ></ValidatorIcon>
          <div class="flex d-flex gap-16">
            <div class="font-type-bold black--text" style="width: 40%">
              4. เป้าหมาย
            </div>
            <div
              style="width: 100%"
              v-html="partTwoForm?.target?.replace(/\n/g, '<br>')"
            ></div>
          </div>
        </div>
      </div>

      <div class="card-part">
        <div class="d-flex align-start gap-24 mb-3">
          <ValidatorIcon
            class="d-flex"
            v-if="!$route.query.preview"
            :is-correct="partTwoValidate('activity')"
          ></ValidatorIcon>
          <div class="flex d-flex gap-16">
            <div class="font-type-bold black--text" style="width: 40%">
              5. รายละเอียดโครงการ
            </div>
            <div style="width: 100%" class="d-flex flex-column gap-24">
              <div>
                <div>
                  {{
                    "1) กิจกรรมบริหารจัดการและพัฒนาเครือข่ายการดําเนินงานอุทยานวิทยาศาสตร์ภูมิภาค (RSP Management)"
                  }}
                </div>
                <div
                  v-for="(item, index) in masterData?.form_b?.form_f_activity[
                    '1'
                  ]"
                  :key="index"
                  class="mt-4"
                >
                  <div class="flex d-flex gap-16">
                    <div style="width: 20%">
                      {{ "กิจกรรม 1." + (index + 1) }}
                    </div>
                    <div>
                      {{ item?.name }}
                    </div>
                  </div>
                  <div class="flex d-flex gap-16">
                    <div style="width: 20%">
                      {{ "วันที่จัดกิจกรรม" }}
                    </div>
                    <div>
                      {{ item?.date }}
                    </div>
                  </div>
                  <div class="flex d-flex gap-16">
                    <div style="width: 20%">
                      {{ "สถานที่" }}
                    </div>
                    <div>
                      {{ item?.location }}
                    </div>
                  </div>
                  <div class="flex d-flex gap-16">
                    <div style="width: 20%">
                      {{ "วิทยากร" }}
                    </div>
                    <div>
                      {{ item?.lecturer }}
                    </div>
                  </div>
                  <div class="flex d-flex gap-16">
                    <div style="width: 20%">
                      {{ "ผู้เข้าร่วม" }}
                    </div>
                    <div>
                      {{ item?.participant }}
                    </div>
                  </div>
                  <div class="flex d-flex gap-16">
                    <div style="width: 20%">
                      {{ "รายละเอียดกิจกรรม" }}
                    </div>
                    <div>
                      {{ item?.description }}
                    </div>
                  </div>
                  <div class="flex d-flex gap-16">
                    <div style="width: 20%">
                      {{ "การอัพโหลดรูปภาพ" }}
                    </div>
                    <a class="theme-color-one" :href="item?.attachment?.url">
                      {{ item?.attachment?.file_name }}
                    </a>
                  </div>
                </div>
              </div>
              <div>
                <div>
                  {{
                    "2) กิจกรรมส่งเสริมกลยุทธ์การสร้างความตระหนักและเผยแพร่ภาพลักษณ์ของอุทยานวิทยาศาสตร์ภูมิภาค(RSP Branding)"
                  }}
                </div>
                <div
                  v-for="(item, index) in masterData?.form_b?.form_f_activity[
                    '2'
                  ]"
                  :key="index"
                  class="mt-4"
                >
                  <div class="flex d-flex gap-16">
                    <div style="width: 20%">
                      {{ "กิจกรรม 2." + (index + 1) }}
                    </div>
                    <div>
                      {{ item?.name }}
                    </div>
                  </div>
                  <div class="flex d-flex gap-16">
                    <div style="width: 20%">
                      {{ "วันที่จัดกิจกรรม" }}
                    </div>
                    <div>
                      {{ item?.date }}
                    </div>
                  </div>
                  <div class="flex d-flex gap-16">
                    <div style="width: 20%">
                      {{ "สถานที่" }}
                    </div>
                    <div>
                      {{ item?.location }}
                    </div>
                  </div>
                  <div class="flex d-flex gap-16">
                    <div style="width: 20%">
                      {{ "วิทยากร" }}
                    </div>
                    <div>
                      {{ item?.lecturer }}
                    </div>
                  </div>
                  <div class="flex d-flex gap-16">
                    <div style="width: 20%">
                      {{ "ผู้เข้าร่วม" }}
                    </div>
                    <div>
                      {{ item?.participant }}
                    </div>
                  </div>
                  <div class="flex d-flex gap-16">
                    <div style="width: 20%">
                      {{ "รายละเอียดกิจกรรม" }}
                    </div>
                    <div>
                      {{ item?.description }}
                    </div>
                  </div>
                  <div class="flex d-flex gap-16">
                    <div style="width: 20%">
                      {{ "การอัพโหลดรูปภาพ" }}
                    </div>
                    <a class="theme-color-one" :href="item?.attachment?.url">
                      {{ item?.attachment?.file_name }}
                    </a>
                  </div>
                </div>
              </div>
              <div>
                <div>
                  {{
                    "3) กิจกรรมพัฒนาทักษะและศักยภาพเบื้องต้นบุคลากรอุทยานวิทยาศาสตร์ภูมิภาค (RSP Skill up)"
                  }}
                </div>
                <div
                  v-for="(item, index) in masterData?.form_b?.form_f_activity[
                    '3'
                  ]"
                  :key="index"
                  class="mt-4"
                >
                  <div class="flex d-flex gap-16">
                    <div style="width: 20%">
                      {{ "กิจกรรม 3." + (index + 1) }}
                    </div>
                    <div>
                      {{ item?.name }}
                    </div>
                  </div>
                  <div class="flex d-flex gap-16">
                    <div style="width: 20%">
                      {{ "วันที่จัดกิจกรรม" }}
                    </div>
                    <div>
                      {{ item?.date }}
                    </div>
                  </div>
                  <div class="flex d-flex gap-16">
                    <div style="width: 20%">
                      {{ "สถานที่" }}
                    </div>
                    <div>
                      {{ item?.location }}
                    </div>
                  </div>
                  <div class="flex d-flex gap-16">
                    <div style="width: 20%">
                      {{ "วิทยากร" }}
                    </div>
                    <div>
                      {{ item?.lecturer }}
                    </div>
                  </div>
                  <div class="flex d-flex gap-16">
                    <div style="width: 20%">
                      {{ "ผู้เข้าร่วม" }}
                    </div>
                    <div>
                      {{ item?.participant }}
                    </div>
                  </div>
                  <div class="flex d-flex gap-16">
                    <div style="width: 20%">
                      {{ "รายละเอียดกิจกรรม" }}
                    </div>
                    <div>
                      {{ item?.description }}
                    </div>
                  </div>
                  <div class="flex d-flex gap-16">
                    <div style="width: 20%">
                      {{ "การอัพโหลดรูปภาพ" }}
                    </div>
                    <a class="theme-color-one" :href="item?.attachment?.url">
                      {{ item?.attachment?.file_name }}
                    </a>
                  </div>
                </div>
              </div>
              <div>
                <div>
                  {{
                    "4) กิจกรรมพัฒนาทักษะและศักยภาพเบื้องต้นบุคลากรอุทยานวิทยาศาสตร์ภูมิภาค"
                  }}
                </div>
                <div
                  v-for="(item, index) in masterData?.form_b?.form_f_activity[
                    '4'
                  ]"
                  :key="index"
                  class="mt-4"
                >
                  <div class="flex d-flex gap-16">
                    <div style="width: 20%">
                      {{ "กิจกรรม 4." + (index + 1) }}
                    </div>
                    <div>
                      {{ item?.name }}
                    </div>
                  </div>
                  <div class="flex d-flex gap-16">
                    <div style="width: 20%">
                      {{ "วันที่จัดกิจกรรม" }}
                    </div>
                    <div>
                      {{ item?.date }}
                    </div>
                  </div>
                  <div class="flex d-flex gap-16">
                    <div style="width: 20%">
                      {{ "สถานที่" }}
                    </div>
                    <div>
                      {{ item?.location }}
                    </div>
                  </div>
                  <div class="flex d-flex gap-16">
                    <div style="width: 20%">
                      {{ "วิทยากร" }}
                    </div>
                    <div>
                      {{ item?.lecturer }}
                    </div>
                  </div>
                  <div class="flex d-flex gap-16">
                    <div style="width: 20%">
                      {{ "ผู้เข้าร่วม" }}
                    </div>
                    <div>
                      {{ item?.participant }}
                    </div>
                  </div>
                  <div class="flex d-flex gap-16">
                    <div style="width: 20%">
                      {{ "รายละเอียดกิจกรรม" }}
                    </div>
                    <div>
                      {{ item?.description }}
                    </div>
                  </div>
                  <div class="flex d-flex gap-16">
                    <div style="width: 20%">
                      {{ "การอัพโหลดรูปภาพ" }}
                    </div>
                    <a class="theme-color-one" :href="item?.attachment?.url">
                      {{ item?.attachment?.file_name }}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </divcard>

    <!--  PART THREE  -->
    <divcard titled>
      <!--      FORM 1-->
      <div class="card-part pt-0 s3-p1-h">
        <div class="txt-head black--text mb-2">
          <span class="theme-color-one">ส่วนที่ 3 :</span> แผนการดำเนินงาน
        </div>

        <!-- Form 1 -->
        <div>
          <div class="d-flex align-center gap-24 mb-3">
            <ValidatorIcon
              v-if="!$route.query.preview"
              :is-correct="partThreeValidate('one')"
            ></ValidatorIcon>
            <div class="font-type-bold black--text">
              1.แผนการดำเนินงาน (จัดทำในรูปเเบบ Project based management)
              <!--<span class="theme-color-seven txt-normal">(โปรดระบุ)</span>-->
            </div>
          </div>

          <!--   PLAN HEADERS   -->
          <div class="py-5 overflow-x-auto mx-n6 px-6 scroll s3-p1">
            <div class="d-flex justify-space-between gap-8 px-3 mb-3">
              <div class="flex" style="min-width: 120px; max-width: 120px">
                กิจกรรม
              </div>
              <div class="flex" style="min-width: 61px; max-width: 61px">
                WF
              </div>
              <div
                v-for="(m, ind) in shortMonths"
                :key="ind"
                class="flex"
                style="min-width: 43px; max-width: 43px"
              >
                <div class="text-center">{{ m.month }}</div>
                <div class="text-center">{{ m.year }}</div>
              </div>
              <div class="flex" style="min-width: 43px; max-width: 43px">
                แผนผล
              </div>
              <div
                class="flex text-center"
                style="min-width: 43px; max-width: 43px"
              >
                %
              </div>
            </div>

            <!--   PLAN ITEMS   -->
            <div
              v-if="partThreeAllPlans && partThreeAllPlans.length > 0"
              class="d-flex flex-column gap-12"
            >
              <div
                v-for="(item, i) in partThreeAllPlans"
                :key="i"
                class="plan-card d-flex justify-space-between gap-8 no-box-shadow"
              >
                <div class="d-block">
                  <div
                    class="flex two-line"
                    style="min-width: 120px; max-width: 120px; max-height: 45px"
                  >
                    <!-- {{ item.p1_activity_name }} -->
                    <tooltip-text :text="item.p1_activity_name" />
                  </div>
                </div>
                <div
                  class="flex d-flex justify-space-between"
                  style="min-width: 61px; max-width: 61px; height: 54px"
                >
                  <v-divider vertical></v-divider>
                  <div
                    class="tiny-field tf-active"
                    style="min-width: 40px; max-width: 40px; height: 100%"
                  >
                    {{ item.p1_wf }}
                  </div>
                  <v-divider vertical></v-divider>
                </div>
                <div
                  v-for="(m, ind) in shortMonths"
                  :key="ind"
                  class="flex d-flex flex-column gap-8"
                  style="min-width: 43px; max-width: 43px"
                >
                  <div class="tiny-field">
                    {{ item.project_section_plan_month[ind].month_value ? item.project_section_plan_month[ind].month_value : "-" }}
                  </div>
                  <div v-if="isFinal" class="tiny-field">
                    {{ item.project_section_plan_month[ind].actual_month_value ? item.project_section_plan_month[ind].actual_month_value : "-" }}
                  </div>
                </div>
                <div
                  class="flex d-flex flex-column gap-8"
                  style="min-width: 43px; max-width: 43px"
                >
                  <div class="tiny-field">
                    {{
                      item.project_section_plan_month[currIndex]?.month_value ||
                      "-"
                    }}
                  </div>
                  <div v-if="isFinal" class="tiny-field">
                    {{
                      item.project_section_plan_month[currIndex]
                        ?.actual_month_value || "-"
                    }}
                  </div>
                </div>
                <div
                  class="flex d-flex flex-column gap-8"
                  style="min-width: 43px; max-width: 43px"
                >
                  <div class="tiny-field">
                    {{
                      item.project_section_plan_month[shortMonths.length - 1]
                        ?.month_value || "-"
                    }}
                  </div>
                  <div v-if="isFinal" class="tiny-field">
                    {{
                      formatNumber(
                        parseFloat(
                          item.project_section_plan_month[currIndex]
                            ?.actual_month_value * 100
                        ) /
                          parseFloat(
                            item.project_section_plan_month[currIndex]
                              ?.month_value
                          ),
                        2
                      )
                    }}
                  </div>
                </div>
              </div>

              <!--   SUMMARY   -->
              <div class="plan-card no-box-shadow">
                <div class="d-flex justify-space-between gap-8">
                  <div class="flex" style="min-width: 120px; max-width: 120px">
                    แผนงานถ่วงน้ำหนัก
                  </div>
                  <div
                    class="flex d-flex justify-space-between"
                    style="min-width: 61px; max-width: 61px"
                  >
                    <v-divider vertical></v-divider>
                    <div
                      class="tiny-field"
                      :class="{
                        'theme-color-four tf-error': totalWF() !== '1.00',
                      }"
                      style="min-width: 40px; max-width: 40px"
                    >
                      {{ totalWF() }}
                    </div>
                    <v-divider vertical></v-divider>
                  </div>

                  <div
                    v-for="(m, ind) in shortMonths"
                    :key="ind"
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{ weightPlan(ind) }}
                  </div>

                  <div
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{ weightPlan(currIndex) }}
                  </div>
                  <div
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{ weightPlan(shortMonths.length - 1) }}
                  </div>
                </div>

                <v-divider class="my-3"></v-divider>

                <div class="d-flex justify-space-between gap-8">
                  <div class="flex" style="min-width: 120px; max-width: 120px">
                    ผลการดำเนินงาน
                  </div>
                  <div
                    class="flex d-flex justify-space-between"
                    style="min-width: 61px; max-width: 61px"
                  >
                    <v-divider vertical></v-divider>
                    <div style="min-width: 40px; max-width: 40px"></div>
                    <v-divider vertical></v-divider>
                  </div>
                  <div
                    v-for="(m, ind) in shortMonths"
                    :key="ind"
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{ isFinal ? weightPlan(ind, "actual_month_value") : "-" }}
                  </div>
                  <div
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{
                      isFinal
                        ? weightPlan(currIndex, "actual_month_value")
                        : "-"
                    }}
                  </div>
                  <div
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{
                      isFinal
                        ? formatNumber(
                            parseFloat(
                              weightPlan(currIndex, "actual_month_value") * 100
                            ) / parseFloat(weightPlan(currIndex)),
                            2
                          )
                        : "-"
                    }}
                  </div>
                </div>

                <v-divider class="my-3"></v-divider>

                <div class="d-flex justify-space-between gap-8">
                  <div class="flex" style="min-width: 120px; max-width: 120px">
                      <ValidatorIcon
                      v-if="!$route.query.preview"
                      :is-correct="validatePlanBudget()"
                    ></ValidatorIcon>
                    <div style="margin-left: 6px;">
                      แผนการใช้จ่ายจริง
                    </div>
                  </div>
                  <div
                    class="flex d-flex justify-space-between"
                    style="min-width: 61px; max-width: 61px"
                  >
                    <v-divider vertical></v-divider>
                    <div style="min-width: 40px; max-width: 40px"></div>
                    <v-divider vertical></v-divider>
                  </div>
                  <div
                    v-for="(m, ind) in shortMonths"
                    :key="ind"
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{
                      partThreeBudgetPlans[ind]?.plan_budget_rate
                        ? partThreeBudgetPlans[ind]?.plan_budget_rate
                        : "-"
                    }}
                  </div>
                  <div
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{
                      partThreeBudgetPlans[currIndex]?.plan_budget_rate
                        ? partThreeBudgetPlans[currIndex].plan_budget_rate
                        : "-"
                    }}
                  </div>
                  <div
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{
                      partThreeBudgetPlans[shortMonths.length - 1]
                        ?.plan_budget_rate
                        ? partThreeBudgetPlans[shortMonths.length - 1]
                            ?.plan_budget_rate
                        : "-"
                    }}
                  </div>
                </div>
                <v-divider class="my-3"></v-divider>

                <div class="d-flex justify-space-between gap-8">
                  <div class="flex" style="min-width: 120px; max-width: 120px">
                    การใช้จ่ายจริง
                  </div>
                  <div
                    class="flex d-flex justify-space-between"
                    style="min-width: 61px; max-width: 61px"
                  >
                    <v-divider vertical></v-divider>
                    <div style="min-width: 40px; max-width: 40px"></div>
                    <v-divider vertical></v-divider>
                  </div>
                  <div
                    v-for="(m, ind) in shortMonths"
                    :key="ind"
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{
                      isFinal && partThreeBudgetPlans[ind]?.use_budget_rate
                        ? formatNumber(
                            partThreeBudgetPlans[ind].use_budget_rate,
                            2
                          )
                        : "-"
                    }}
                  </div>
                  <div
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{
                      isFinal &&
                      partThreeBudgetPlans[currIndex]?.use_budget_rate
                        ? formatNumber(
                            partThreeBudgetPlans[currIndex].use_budget_rate,
                            2
                          )
                        : "-"
                    }}
                  </div>
                  <div
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{
                      isFinal
                        ? formatNumber(
                            parseFloat(
                              partThreeBudgetPlans[currIndex]?.use_budget_rate *
                                100
                            ) /
                              parseFloat(
                                partThreeBudgetPlans[currIndex]
                                  ?.plan_budget_rate
                              ),
                            2
                          )
                        : "-"
                    }}
                  </div>
                </div>
              </div>
            </div>

            <div v-else class="no-plan-item">ไม่มีข้อมูล</div>
          </div>
        </div>
      </div>
      <!--      FORM 2-->
      <div class="card-part">
        <div class="mb-5">
          <div class="d-flex align-center gap-24 mb-3">
            <ValidatorIcon
              v-if="!$route.query.preview"
              :is-correct="partThreeValidate('two')"
            ></ValidatorIcon>
            <div class="font-type-bold black--text">
              2. งบประมาณ (รายละเอียดการประเมินค่าใช้จ่ายในโครงการ)
              <!--              <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>-->
            </div>
          </div>

          <div class="d-flex theme-color-eight px-3 mb-3 gap-12">
            <div style="width: 10%">รายการ</div>
            <div style="width: 25%">รายละเอียด</div>
            <div class="text-end" style="width: 10%">Unit Cost (บาท)</div>
            <div class="text-end" style="width: 10%">จำนวน</div>
            <div class="text-end" style="width: 19%">หน่วย</div>
            <div class="text-end" style="width: 18%">งบประมาณ (บาท)</div>
          </div>

          <div class="d-flex flex-column gap-16">
            <div
              v-for="(item, i) in partThreeBudgetList"
              :key="i"
              class="budget-item no-box-shadow"
            >
              <div class="d-flex black--text gap-12">
                <div style="width: 10%">{{ item.budget_name }}</div>
                <div
                  style="width: 25%"
                  v-html="item.budget_detail?.replace(/\n/g, '<br>')"
                ></div>
                <div class="text-end" style="width: 10%">
                  {{ formatNumber(item.budget_cost, 2) }}
                </div>
                <div class="text-end" style="width: 10%">
                  {{ formatNumber(item.budget_amount, 2) }}
                </div>
                <div class="text-end" style="width: 19%">
                  {{ item.budget_unit }}
                </div>
                <div class="text-end" style="width: 18%">
                  {{ formatNumber(item.budgets, 2) }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="partThreeBudgetList && partThreeBudgetList?.length > 0"
          class="d-flex flex-column gap-12 px-12 mb-5"
        >
          <div class="d-flex justify-space-between">
            <div class="black--text">
              รวมลำดับที่ 1-{{ partThreeBudgetList?.length }}
            </div>
            <div class="theme-color-one">
              {{
                formatNumber(
                  partThreeBudgetList
                    .map((x) => x.budgets)
                    .reduce((a, b) => parseFloat(a) + parseFloat(b), 0),
                  2
                )
              }}
              บาท
            </div>
          </div>
          <!-- <div class="d-flex justify-space-between">
            <div class="black--text">รวมค่าใช้จ่ายสุทธิ</div>
            <div class="theme-color-one">
              {{
                formatNumber(
                  partThreeBudgetList
                    .map((x) => parseFloat(x.budget_sum))
                    .reduce((a, b) => a + b, 0),
                  2
                )
              }}
              บาท
            </div>
          </div> -->
        </div>
      </div>
    </divcard>

    <!--  PART FOUR  -->
    <divcard titled>
      <div class="card-part pt-0">
        <div class="txt-head black--text mb-2">
          <span class="theme-color-one">ส่วนที่ 4 :</span> ผลผลิต /
          ตัวชี้วัดความสำเร็จ
        </div>

        <!-- Form 1 -->
        <div>
          <div class="d-flex align-center gap-24 mb-3">
            <ValidatorIcon
              v-if="!$route.query.preview"
              :is-correct="partFourValidate('one')"
            ></ValidatorIcon>
            <div class="font-type-bold black--text">
              1. ตัวชี้วัดความสำเร็จ
              <!--              <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>-->
            </div>
          </div>

          <div
            v-for="(item, i) in masterData?.form_b?.form_ab_general_info?.dynamic_kpi"
            :key="i"
            class="d-flex flex-column gap-16 mx-10"
          >
            <div>
              {{ "ตัวชี้วัดที่ " + item?.no + " " + item?.name }}
            </div>
            <div class="mx-5" style="width: 100%">
              <div
                v-for="(item, i) in item?.sub"
                :key="i"
                class="flex d-flex gap-16"
              >
                <div style="width: 70%">
                  {{ item?.name }}
                </div>
                <div style="width: 10%">
                  {{ item?.amount }}
                </div>
                <div style="width: 20%">
                  {{ item?.unit }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card-part">
        <div class="font-type-bold black--text mb-3 d-flex gap-24">
          <ValidatorIcon
            v-if="!$route.query.preview"
            :is-correct="partFourValidate('two')"
          ></ValidatorIcon>
          2. ผลผลิตและตัวชี้วัดความสำเร็จ
        </div>
        <div class="d-flex align-start gap-24">
          <div class="flex d-flex gap-16 mx-10">
            <div style="width: 40%">ในเชิงเศรษฐกิจ</div>
            <div style="width: 100%">
              {{ masterData?.form_b?.form_ab_general_info?.indicator_economy }}
            </div>
          </div>
        </div>
      </div>

      <div class="card-part">
        <div class="font-type-bold black--text mb-3 d-flex gap-24">
          <ValidatorIcon
            v-if="!$route.query.preview"
            :is-correct="partFourValidate('three')"
          ></ValidatorIcon>
          3. ผลลัพธ์
        </div>
        <div class="d-flex align-start gap-24">
          <div class="flex d-flex gap-16 mx-10">
            <div style="width: 40%">ด้านเศรษฐกิจ</div>
            <div style="width: 100%">
              {{ masterData?.form_b?.form_ab_general_info?.result_economy }}
            </div>
          </div>
        </div>
        <div class="d-flex align-start gap-24">
          <div class="flex d-flex gap-16 mx-10">
            <div style="width: 40%">ด้านสังคม</div>
            <div style="width: 100%">
              {{ masterData?.form_b?.form_ab_general_info?.result_environment }}
            </div>
          </div>
        </div>
        <div class="d-flex align-start gap-24">
          <div class="flex d-flex gap-16 mx-10">
            <div style="width: 40%">ด้านสิ่งแวดล้อม</div>
            <div style="width: 100%">
              {{ masterData?.form_b?.form_ab_general_info?.result_society }}
            </div>
          </div>
        </div>
      </div>

      <div
          v-if="
                (isOIC) ||
                (!isOIC && partOneForm.ops_comment)
              "
          class="card-part" >
        <div class="font-type-bold black--text mb-3 d-flex gap-24">
          <ValidatorIcon
            v-if="!$route.query.preview"
            :is-correct="partFourValidate('four')"
          ></ValidatorIcon>
          4. ความคิดเห็น/ข้อเสนอแนะ
        </div>
        <div class="d-flex align-start gap-24">
          <div class="flex d-flex gap-16 mx-10">
            <div style="width: 100%">
              {{ masterData?.form_b?.form_ab_general_info?.ops_comment }}
            </div>
          </div>
        </div>
      </div>
    </divcard>

    <!--  PART FIVE  -->
    <divcard titled>
      <div class="card-part pt-0">
        <div class="txt-head black--text d-flex justify-space-between mb-3">
          <div><span class="theme-color-one">ส่วนที่ 5 :</span> เอกสารแนบ</div>
        </div>

        <!-- Form 5 -->
        <div>
          <v-layout
            align-center
            class="mt-3"
            v-for="(file, f) in partFiveAttachment.filter(
              (f) => f.doc_type !== 'annex'
            )"
            :key="f"
          >
            <v-flex shrink class="to-hide">
              <v-btn
                depressed
                dark
                rounded
                width="125"
                color="#F15A29"
                @click="downloadFile(file)"
              >
                <Iconify
                  style="color: #fff"
                  icon="system-uicons:download"
                ></Iconify>
                <span class="font-12 font-w-700">ดาวน์โหลด</span>
              </v-btn>
            </v-flex>
            <v-flex shrink ml-3>
              {{ file.file_name }}
            </v-flex>
          </v-layout>
        </div>
      </div>
    </divcard>
  </div>
</template>

<script>
import TextField from "../../../components/input/TextField";
import SwitchInset from "../../../components/input/SwitchInset";
import AutoBox from "../../../components/input/AutoBox";
import {
  eventBus,
  formatNumber,
  validateEmail,
} from "../../../plugins/global-funcs";
import { mapState } from "vuex";
import OOILineField from "../../../components/OOILineField";
import ValidatorIcon from "../../../components/ValidatorIcon";
import { apiDomain } from "@/store/constants";
import axios from "axios";
import { format } from "date-fns";
import { th } from "date-fns/locale";

export default {
  name: "AFormSummary",
  components: {
    TextField,
    SwitchInset,
    AutoBox,
    OOILineField,
    ValidatorIcon,
  },
  props: {
    masterData: {
      default: () => ({}),
    },
    isSameId: {
      default: false,
    },
  },
  data() {
    return {
      formatNumber,
      tempPlan: {},
      partOneForm: {},
      partTwoForm: {},
      shortMonths: [],
      partThreeForm: {},
      partThreeAllPlans: [],
      partThreeBudgetList: [],
      partThreeAllProgressPlan: [],
      partThreeBudgetPlans: [],
      partFourForm: {},
      kpi_annex_plans: [],
      kpi: {},
      annexProjects: [],
      partFiveAttachment: [],
      ableToSubmit: true,
      fiscalYear: null,
      total_plan_budget_month: [],
      total_use_budget_month: [],
      currIndex: 0,
      allPlansFormB: [],
    };
  },
  computed: {
    ...mapState({
      isOIC: (state) => state.Auth.User.user_type === "สป.อว.",
      userRole: (state) => state.Auth.User.user_type,
      user: (state) => state.Auth.User,
    }),
    isFinal() {
      return (
        this.$route.query.doc_type && this.$route.query.doc_type === "progress"
      );
    },
  },
  async created() {
    this.ableToSubmit = true;
    this.fiscalYear = this.masterData.form_b?.fiscal_year;
    // PART ONE
    this.partOneForm = this.masterData.form_b?.form_ab_general_info;
    // PART TWO
    this.partTwoForm = this.masterData.form_b?.form_ab_project_info;
    // PART THREE
    this.setupBudgetYearMonth();
    this.partThreeForm = this.masterData.form_b?.project_section_plan;
    this.partThreeAllPlans =
      this.masterData.form_b?.project_section_plan?.project_plan_p1;
    this.allPlansFormB = this.mapFormBPlanData(this.masterData.form_b || []);
    this.partThreeBudgetPlans =
      this.masterData.form_b?.project_section_plan
        ?.project_section_plan_p1_budget || [];
    this.partThreeBudgetList =
      this.masterData.form_b?.project_section_plan?.project_section_budget_df;
    this.kpi_annex_plans = this.masterData.form_b?.kpi_annex_plans;
    this.partFiveAttachment = this.masterData.form_b?.attachments || [];
    this.currIndex = this.getCurrIndex();
    if (this.masterData.form_b) {
      this.form = this.masterData.form_b.project_section;
      for (const x of this.masterData.kpi_masters) {
        for (const y of x.kpi_sub_masters) {
          if (y.kpi_sub_values) {
            let subId = y.kpi_sub_values.kpi_sub_master_id.toString();
            this.kpi[subId] = {};
            this.kpi[subId].id = y.kpi_sub_values.id;
            this.kpi[subId].kpi_sub_master_id =
              y.kpi_sub_values.kpi_sub_master_id;
            this.kpi[subId].kpi_sub_value = y.kpi_sub_values.kpi_sub_value;
          }
        }
      }
    }
  },
  methods: {
    totalWF() {
      if (!this.partThreeAllPlans || this.partThreeAllPlans?.length === 0)
        return "-";
      let total = this.partThreeAllPlans
        .map((x) => x.p1_wf)
        .reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
      if (typeof total === "number") return total.toFixed(2);
      return total;
    },
    getCurrIndex() {
      let ind = 0;
      for (const x of this.partThreeAllPlans) {
        let i = 0;
        for (const y of x.project_section_plan_month) {
          let correctIndex = this.isInCorrectRange(y, i);
          if (typeof correctIndex !== "boolean") return correctIndex;
          i++;
        }
        ind++;
      }
    },
    isInCorrectRange(item, index = null) {
      let today = new Date();
      let currentMonth = today.getMonth();
      let thisMonth = new Date(item.year_month).getMonth();

      let isCorrectCase = thisMonth === currentMonth;

      // for return active yearMonth index
      if (isCorrectCase && index !== null) return index;

      return isCorrectCase;
    },
    mapFormBPlanData(form_b_list) {
      let plan_data = [];
      let wf = 0;
      let plan_count = 0;
      Object.values(form_b_list).forEach((form_b) => {
        if (
          form_b?.project_section_plan?.project_section_plan_p1_budget &&
          form_b?.project_section_plan?.project_section_plan_p1_budget?.length >
            0
        )
          plan_count++;
      });
      if (plan_count === 0) wf = 1.0;
      else wf = (1 / plan_count).toFixed(2);

      let total_amount = 0;
      let total_plan_budget_month = [];
      let total_use_budget_month = [];
      let month_length = 0;
      Object.values(form_b_list).forEach((form_b, index) => {
        if (index === form_b_list?.length - 1)
          wf = 1.0 - wf * (form_b_list?.length - 1);
        total_amount =
          parseFloat(total_amount) + parseFloat(form_b?.budget_amount);
        if (
          form_b?.project_section_plan?.project_section_plan_p1_budget &&
          form_b?.project_section_plan?.project_section_plan_p1_budget?.length >
            0
        ) {
          let plan = {
            p1_activity_name: form_b?.plan.plan_master.plan_name_th,
            p1_wf: wf,
            project_section_plan_month:
              form_b?.project_section_plan?.project_section_plan_p1_budget,
            percent:
              form_b?.project_section_plan?.project_section_plan_p1_budget.slice(
                -1
              ).month_value,
          };
          month_length = plan.project_section_plan_month?.length;
          for (let i = 0; i < month_length; i++) {
            if (!total_plan_budget_month[i]) total_plan_budget_month[i] = 0.0;
            if (!total_use_budget_month[i]) total_use_budget_month[i] = 0.0;
            total_plan_budget_month[i] = (
              parseFloat(total_plan_budget_month[i]) +
              parseFloat(plan.project_section_plan_month[i].plan_budget_sum)
            ).toFixed(2);
            total_use_budget_month[i] = (
              parseFloat(total_use_budget_month[i]) +
              parseFloat(plan.project_section_plan_month[i].use_budget_sum)
            ).toFixed(2);
          }
          console.log("total_use_budget_month1", total_use_budget_month);
          plan_data.push(plan);
        }
      });

      console.log("plan_data", plan_data);
      console.log("total_use_budget_month", total_use_budget_month);
      console.log("total_plan_budget_month", total_plan_budget_month);
      console.log("total_amount", total_amount);
      for (let ind = 0; ind < month_length; ind++) {
        total_use_budget_month[ind] = (
          (parseFloat(total_use_budget_month[ind]) /
            parseFloat(total_plan_budget_month[ind])) *
          100
        ).toFixed(2);
        total_plan_budget_month[ind] = (
          (parseFloat(total_plan_budget_month[ind]) /
            parseFloat(total_amount)) *
          100
        ).toFixed(2);
      }
      console.log("total_use_budget_month2", total_use_budget_month);
      this.total_plan_budget_rate = total_plan_budget_month;
      this.total_use_budget_rate = total_use_budget_month;
      return plan_data;
    },
    weightPlan(index) {
      let total = [];
      for (const x of this.partThreeAllPlans) {
        let result = x.project_section_plan_month[index]
          ? parseFloat(
              x.project_section_plan_month[index].month_value * x.p1_wf
            )
          : 0;
        if (!isNaN(result)) {
          total.push(result);
        }
      }
      if (total?.length > 0) {
        total = total.reduce((a, b) => a + b, 0);
      } else {
        total = "-";
      }
      if (typeof total === "number") return total.toFixed(2);
      return total;
    },
    totalWFFormB() {
      if (!this.allPlansFormB || this.allPlansFormB?.length === 0) return "-";
      let total = this.allPlansFormB
        .map((x) => x.p1_wf)
        .reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
      if (typeof total === "number") return total.toFixed(2);
      return total;
    },
    weightPlanFormB(index, field = "month_value") {
      let total = [];
      for (const x of this.allPlansFormB) {
        let result = parseFloat(
          x.project_section_plan_month[index][field] * x.p1_wf
        );
        if (!isNaN(result)) {
          total.push(result);
        }
      }
      if (total?.length > 0) {
        total = total.reduce((a, b) => a + b, 0);
      } else {
        total = "-";
      }
      if (typeof total === "number") return total.toFixed(2);
      return total;
    },
    allowFormAbleSubmit(isCorrect) {
      if (!isCorrect) {
        this.ableToSubmit = false;
      }
      eventBus.$emit("aFormAbleToSubmit", this.ableToSubmit);
    },
    partOneValidate(section) {
      let isCorrect = true;
      switch (section) {
        case "master_plan":
          if (!this.masterData?.form_b?.plan?.plan_master?.plan_name_th) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "sci_park":
          if (
            !this.partOneForm?.sci_park ||
            this.partOneForm?.sci_park?.length < 1
          ) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "pm_name":
          if (
            !this.partOneForm?.pm_name ||
            this.partOneForm?.pm_name?.length < 1
          ) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "pm_position":
          if (
            !this.partOneForm?.pm_position ||
            this.partOneForm?.pm_position?.length < 1 ||
            !this.partOneForm?.pm_org ||
            this.partOneForm?.pm_org?.length < 1
          ) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "pm_mobile_phone":
          if (
            !this.partOneForm?.pm_mobile_phone ||
            !validateEmail(this.partOneForm?.pm_email)
          ) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "pc_name":
          if (
            !this.partOneForm?.pc_name ||
            this.partOneForm?.pc_name?.length < 1
          ) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "pc_position":
          if (
            !this.partOneForm?.pc_position ||
            this.partOneForm?.pc_position?.length < 1 ||
            !this.partOneForm?.pc_org ||
            this.partOneForm?.pc_org?.length < 1
          ) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "pc_mobile_phone":
          if (
            !this.partOneForm?.pc_mobile_phone ||
            !validateEmail(this.partOneForm?.pc_email)
          ) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;
      }
    },
    partTwoValidate(section) {
      let isCorrect = true;
      switch (section) {
        case "activity": {
          console.log("this.masterData?.form_b?.form_f_activity", this.masterData?.form_b?.form_f_activity);
          const activities = this.masterData?.form_b?.form_f_activity || {};

              for (const key of ["1", "2", "3", "4"]) {
                const sectionActivities = activities[key];

                // ถ้าไม่มี section นี้ หรือ array ว่าง
                if (!sectionActivities || sectionActivities.length === 0) {
                  isCorrect = false;
                  continue;
                }

                for (const activity of sectionActivities) {
                  // ถ้าไม่มี attachment เลย
                  if (!activity.attachment) {
                    isCorrect = false;
                    continue;
                  }

                  // normalize: บางครั้งเป็น object เดียว ไม่ใช่ array
                  const atts = Array.isArray(activity.attachment)
                    ? activity.attachment
                    : [activity.attachment];

                  for (const att of atts) {
                    if (!att.id && !att.file_name) {
                      // ไม่มี id หรือไม่มี file_name → ถือว่าไม่ถูกต้อง
                      isCorrect = false;
                    }
                  }
                }
              }
                              

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;
        }

        case "principle":
          if (
            !this.partTwoForm?.principle ||
            this.partTwoForm?.principle?.length < 1
          ) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "objective":
          if (
            !this.partTwoForm?.objective ||
            this.partTwoForm?.objective?.length < 1
          ) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "solution":
          if (
            !this.partTwoForm?.solution ||
            this.partTwoForm?.solution?.length < 1
          ) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "progress":
          if (
            !this.partTwoForm?.progress ||
            this.partTwoForm?.progress?.length < 1
          ) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "industry_group":
          if (
            !this.partTwoForm?.industry_group ||
            this.partTwoForm?.industry_group?.length < 1
          ) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "target":
          if (
            !this.partTwoForm?.target ||
            this.partTwoForm?.target?.length < 1
          ) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "sci_park_mgm":
          if (
            !this.partTwoForm?.sci_park_mgm ||
            this.partTwoForm?.sci_park_mgm?.length < 1
          ) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "coop_dep":
          if (
            !this.partTwoForm?.coop_dep ||
            this.partTwoForm?.coop_dep?.length < 1
          ) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "seven":
          if (
            !this.partTwoForm?.perf_serv_plat ||
            this.partTwoForm?.perf_serv_plat?.length < 1 ||
            !this.partTwoForm?.perf_sti ||
            this.partTwoForm?.perf_sti?.length < 1 ||
            !this.partTwoForm?.perf_irtc ||
            this.partTwoForm?.perf_irtc?.length < 1 ||
            !this.partTwoForm?.perf_collab_resh ||
            this.partTwoForm?.perf_collab_resh?.length < 1
          ) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;
      }
    },
    partThreeValidate(section) {
      let isCorrect = true;
      switch (section) {
        case "one":
          if (
            !this.partThreeAllPlans ||
            this.partThreeAllPlans.length < 1 ||
            this.totalWF() !== "1.00"
          ) {
            isCorrect = false;
          }

          // validate form ต้องกรอกอย่างน้อย 1 รายการ และต้องไม่เป็น 0
          if (
            this.partThreeBudgetPlans.filter((x) => x.plan_budget !== "")
              .length === 0 ||
            this.partThreeBudgetPlans.filter((x) => x.plan_budget != 0)
              .length === 0 ||
            this.partThreeBudgetPlans.filter((x) => x.plan_budget != "0.00")
              .length === 0
          ) {
            isCorrect = false;
          }

          // validate ผลรวมแผนการใช้จ่ายต้องเท่ากับงบประมาณที่กำหนด
          if (
            this.partThreeBudgetPlans
              .map((x) => parseFloat(x.plan_budget ? x.plan_budget : 0))
              .reduce((a, b) => a + b, 0) !==
            this.partThreeBudgetList
              .map((x) => parseFloat(x.budgets))
              .reduce((a, b) => a + b, 0)
          ) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "two":
          if (
            !this.partThreeBudgetList ||
            this.partThreeBudgetList.length < 1
          ) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;
      }
    },
        validatePlanBudget() {
      let isCorrect = true;
      // validate form ต้องกรอกอย่างน้อย 1 รายการ และต้องไม่เป็น 0
     if (
            this.partThreeBudgetPlans.filter((x) => x.plan_budget !== "")
              .length === 0 ||
            this.partThreeBudgetPlans.filter((x) => x.plan_budget != 0)
              .length === 0 ||
            this.partThreeBudgetPlans.filter((x) => x.plan_budget != "0.00")
              .length === 0
          ) {
            isCorrect = false;
          }

          // validate ผลรวมแผนการใช้จ่ายต้องเท่ากับงบประมาณที่กำหนด
          if (
            this.partThreeBudgetPlans
              .map((x) => parseFloat(x.plan_budget ? x.plan_budget : 0))
              .reduce((a, b) => a + b, 0) !==
            this.partThreeBudgetList
              .map((x) => parseFloat(x.budgets))
              .reduce((a, b) => a + b, 0)
          ) {
            isCorrect = false;
          }
      return isCorrect;
    },
    partFourValidate(section) {
      let isCorrect = true;
      switch (section) {
        case "one":
          if (this.masterData?.form_b?.form_ab_general_info?.dynamic_kpi.length === 0) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "two":
          if (
            !this.masterData?.form_b?.form_ab_general_info?.indicator_economy
          ) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "three":
          if (
            !this.masterData?.form_b?.form_ab_general_info?.result_economy ||
            !this.masterData?.form_b?.form_ab_general_info
              ?.result_environment ||
            !this.masterData?.form_b?.form_ab_general_info?.result_society
          ) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "four":
          if (!this.masterData?.form_b?.form_ab_general_info?.ops_comment) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "kpi_quantity":
          if (
            !this.partOneForm?.kpi_quantity ||
            this.partOneForm?.kpi_quantity?.length < 1 ||
            !this.partOneForm?.kpi_quality ||
            this.partOneForm?.kpi_quality?.length < 1
          ) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "kpi_annex_plan":
          if (!this.kpi_annex_plans || this.kpi_annex_plans?.length === 0)
            isCorrect = false;
          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "ops_comment":
          if (!this.partOneForm.ops_comment) {
            isCorrect = false;
          }
          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;
      }
    },
    downloadFile(file) {
      axios({
        url: `/api/download/${file.id}`,
        method: "GET",
        responseType: "blob",
      })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", file.file_name);
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          this.$store.commit("General/setModal", {
            title: "ระบบไม่พบไฟล์ที่ร้องขอ",
            theme: "warning",
            text: "กรุณาติดต่อเจ้าหน้าที่",
            showCancel: false,
            buttonText: "ตกลง",
          });
        });
    },
    setupBudgetYearMonth() {
      let ym = new Date((this.fiscalYear - 544).toString() + "-10");
      let countMonths = 12;
      if (this.isFinal && this.masterData.form_b?.progress_month && this.masterData.form_b?.progress_month > 12) {
        countMonths += this.masterData.form_b.progress_month - 12;
      }
      for (let i = 0; i < countMonths; i++) {
        this.shortMonths.push({
          key: i + 1,
          month: format(ym, "MMM", { locale: th }),
          year: (parseInt(ym.toISOString().substr(0, 7).split("-")[0]) + 543)
            .toString()
            .slice(2),
        });
        ym = new Date(ym.setMonth(ym.getMonth() + 1));
      }
    },
  },
};
</script>

<style scoped lang="scss">
.budget-item,
.summary-plan {
  background: #ffffff;
  box-shadow: 1px 1px 30px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  padding: 12px;
}

.summary-plan {
  min-height: 78px;
}

.remark-box {
  color: var(--theme-color-seven);
  background: #fafafa;
  border-radius: 20px;
  padding: 12px;
  font-size: 10px;
}

.plan-card {
  background: #ffffff;
  box-shadow: 1px 1px 18px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  border: 1px solid transparent;
  padding: 12px;
  min-width: max-content;
  &.plan-active {
    border: 1px solid var(--theme-color-seven);
  }
}

.plan-field-form {
  /* User input values. */
  --grid-layout-gap: 16px;
  --grid-column-count: 6;
  --grid-item--min-width: 130px;

  /* Calculated values. */
  --gap-count: calc(var(--grid-column-count) - 1);
  --total-gap-width: calc(var(--gap-count) * var(--grid-layout-gap));
  --grid-item--max-width: calc(
    (100% - var(--total-gap-width)) / var(--grid-column-count)
  );

  display: grid;
  grid-template-columns: repeat(
    auto-fill,
    minmax(max(var(--grid-item--min-width), var(--grid-item--max-width)), 1fr)
  );
  grid-gap: var(--grid-layout-gap);
}

.plan-slot > div {
  transition: background-color 400ms;
  background-color: #fff;
  height: 20px;
}
.plan-slot .progress-plan-mark {
  background-color: var(--theme-color-one);
  min-width: 45px;
  display: flex;
  align-items: center;
  padding-top: 1px;
  .v-divider {
    border-color: #fff;
  }
}

.progress-plan-mark.start-point {
  border-radius: 30px 0 0 30px;
  padding-left: 4px;
}

.progress-plan-mark.end-point {
  border-radius: 0 30px 30px 0;
  padding-right: 6px;
}

.arrow-right {
  display: none;
}
.end-point .arrow-right {
  display: unset;
  font-family: "Tahoma", sans-serif;
  margin-left: -8px;
  margin-top: -3px;
  user-select: none;
}
.topic-field {
  min-width: 160px;
  max-width: 160px;
}
.indent-info {
  padding-left: 85px;
}
</style>
